import clsx from 'clsx';
import React, { FC } from 'react';

import styles from './styles.module.css';

interface Props {
  containerClassName?: string;
  className?: string;
}

const Loader: FC<Props> = ({ className, containerClassName }) => {
  return (
    <div className={clsx(styles.loaderContainer, containerClassName)}>
      <div className={clsx(styles.spinner, className)} />
    </div>
  );
};

export default Loader;
